import { useCallback, useEffect, useRef, useState } from "react";
import { fetchAccountingHealth, type AccountingHealth } from "@/api/accounting";

export function useAccountingHealth(autoRefresh = true) {
  const [health, setHealth] = useState<AccountingHealth | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const hasFetched = useRef(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const payload = await fetchAccountingHealth();
      setHealth(payload);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Unable to load accounting health");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!autoRefresh || hasFetched.current) {
      return;
    }
    hasFetched.current = true;
    void refresh().catch(() => {
      /* errors handled via state */
    });
  }, [autoRefresh, refresh]);

  return { health, loading, error, refresh };
}
